import PageHeading from "../../components/page-heading";

import _ from "lodash";
import justice from "../../assets/members/justice.jpg";
import simon from "../../assets/members/simon-peter.jpg";
import christine from "../../assets/members/christine.jpg";
import profile from "../../assets/profile.png";
import Member from "./member";


export default function BoardMembers() {
    const MEMBERS = [
        {
            name: "Hon Justice. Vincent Opyene",
            title: "Chairman Board members",
            image: justice,
        },
        { name: "Dr. Simon Peter Khabusi (PhD)", title: "", image: simon },
        { name: "Hermilia Christine Akoli ", title: "", image: christine },
        { name: "Mr. Dila Ronald Oyuku", title: "", image: profile },
        { name: "Mr. Opaka Leo", title: "Board Member", image: profile },
        { name: "Mr. Stephen Owani Delarosa", title: "", image: profile },
        { name: "Ms Salume Agoro", title: "", image: profile },
        {
            name: "Ms. Bibianna Mirriam Oyuku",
            title: "Board Member",
            image: profile,
        },
        {
            name: "Ms. Caroline Agaro",
            title: "Assistant DHO Oyam District Local Government",
            image: profile,
        },
    ];

    return (
        <div>
            <PageHeading title="Board Members" />
            <div className="py-16 container">
                <div className="max-w-xs mx-auto">
                    <Member member={MEMBERS[0]} />
                </div>
                <div className="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 gap-x-10">
                    {_.map(_.slice(MEMBERS, 1), (m, i) => (
                        <Member key={i} member={m} />
                    ))}
                </div>
            </div>
        </div>
    );
}
